/**
 * Project-level feature rollout. Mirrors ProjectModel.isFeatureEnabledForProject
 * on the API and the mobile helper:
 *  - appdata org_config.project_scoped_features lists the features the org
 *    rolls out project by project, e.g. ['sample_collection'];
 *  - each listed feature is on only for projects whose
 *    source_entity_extra_attributes.<feature>_enabled === true (an org-admin
 *    toggle on the Project settings sub-tab, see project-admin-flags);
 *  - a feature that is not listed stays org-wide.
 *
 * This only answers "which projects in the org"; whether the org has the
 * feature at all (custom groups, org flags) is still the feature's own check.
 */
export function isFeatureEnabledForProject(feature: string, appData: any, project: any): boolean {
  const scoped = appData?.org_config?.project_scoped_features;
  if (!Array.isArray(scoped) || !scoped.includes(feature)) {
    return true;
  }
  return project?.source_entity_extra_attributes?.[`${feature}_enabled`] === true;
}
